/*!
 * throttle v4.1.1
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 *
 * Usage exemple
 * $(window).resize(throttle(250, funtion(){}));
 */

( function( window, factory ) { 'use strict';
	// universal module definition

	/*global define: false, module: false, require: false */

	if ( typeof define == 'function' && define.amd ) {
		// AMD
		define('throttle', factory);
	} else if ( typeof module == 'object' && module.exports ) {
		// CommonJS
		module.exports = factory(
			window
		);
	} else {
		// browser global
		window._raf = factory(
			window
		);
	}

})( window,

// --------------------------  factory -------------------------- //

function factory( b, c ) {

	return (function(){
		return  window.requestAnimationFrame       ||
						window.webkitRequestAnimationFrame ||
						window.mozRequestAnimationFrame    ||
						window.oRequestAnimationFrame      ||
						window.msRequestAnimationFrame     ||
						function(/* function */ callback, /* DOMElement */ element){
								window.setTimeout(callback, 1000 / 60);
						};
	})();



});
